import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Suspense, lazy, useState, useEffect } from 'react';

// Layouts
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';

// Components
import Loading from './components/common/Loading';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Editions from './pages/Editions';
import Samples from './pages/Samples';
import Gallery from './pages/Gallery';
import Video from './pages/Video';
import Subscribe from './pages/Subscribe';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time (e.g., 2.5 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence mode="wait">
      {loading ? (
        // 1. SPLASH SCREEN
        <motion.div key="loader">
          <Loading />
        </motion.div>
      ) : (
        // 2. ACTUAL WEBSITE
        <motion.div
          key="content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Suspense fallback={<div className="h-screen w-full bg-white" />}>
            <Routes location={location} key={location.pathname}>
              
              {/* Main Routes */}
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="editions" element={<Editions />} />
                <Route path="samples" element={<Samples />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="videos" element={<Video />} />
                <Route path="subscribe" element={<Subscribe />} />
                <Route path="contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Admin />} />
              </Route>

            </Routes>
          </Suspense>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default App;